import { CybersourceInstallmentsForm } from './CybersourceInstallmentsForm';

export default CybersourceInstallmentsForm;
